<template>
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="90%"
        class="leader-dialog"
        :close-on-click-modal="false"
        top="10vh"
        @close="closeDialog"
    >
        <el-form class="leader-style-form" :model="addForm" ref="addForm">
            <!-- :disabled="show_day.length" -->
            <el-form-item prop="date" :rules="[{ required: true, message: '请选择月份' }]">
                <el-date-picker
                    v-model="addForm.date"
                    type="month"
                    placeholder="选择月"
                    value-format="yyyy-MM"
                    style="width: 240px"
                    :clearable="false"
                    @change="changeDate"
                ></el-date-picker>
            </el-form-item>
            <el-table
                border
                :data="addForm.tableList"
                class="leader-style-table"
                max-height="490"
                ref="diaTable"
            >
                <el-table-column type="index" width="50" align="center" label="序号" property="num"></el-table-column>
                <template v-for="(column, index) in tableColum">
                    <el-table-column
                        :key="index"
                        align="center"
                        v-if="column.column_name != '月份'"
                        width="0"
                        :label="column.column_name"
                        :property="column.target_main_dtl_id"
                    >
                        <template slot-scope="scope">
                            <el-form-item
                                :prop="
                                    'tableList.' +
                                    scope.$index +
                                    `.${column.target_main_dtl_id}`
                                "
                                :rules="[
                                    {
                                        required:
                                            column.is_required == '1'
                                                ? true
                                                : false,
                                        message: '请输入' + column.column_name,
                                        trigger: 'blur'
                                    }
                                ]"
                            >
                                <el-date-picker
                                    v-if="column.column_type == 10"
                                    v-model="
                                        scope.row[column.target_main_dtl_id]
                                    "
                                    value-format="yyyy-MM"
                                    type="month"
                                    placeholder="选择月"
                                ></el-date-picker>
                                <el-input
                                    v-if="column.column_type == 30"
                                    v-model="
                                        scope.row[column.target_main_dtl_id]
                                    "
                                    :maxlength="column.max_length"
                                ></el-input>
                                <el-input
                                    v-if="column.column_type == 20"
                                    v-model="
                                        scope.row[column.target_main_dtl_id]
                                    "
                                    v-Int.float="{ isNegative: true }"
                                    :maxlength="column.max_length"
                                ></el-input>
                                <template
                                    v-if="column.column_type == null"
                                >{{ scope.row[column.target_main_dtl_id] }}</template>
                            </el-form-item>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button class="leader-common-button" @click="sumitForm">保 存</el-button>
            <el-button @click="dialogVisible = false" class="leader-common-button">取 消</el-button> 
        </span>
    </el-dialog>
</template>
<script>
import * as api from "@/http/target-config.js";
export default {
    data() {
        return {
            addForm: {
                date: "",
                target_main_id: "",
                tableList: []
            },
            tableColum: [],
            tableList: [],
            loading: false
        };
    },
    props: {
        title: String,
        dialogVisible: Boolean,
        point_id: String,
        target_main_id: String,
        show_day: String
    },
    watch: {
        dialogVisible(newVal, oldVal) {
            if (newVal) {
                this.addForm.target_main_id = this.target_main_id;
                this.addForm.date = this.show_day;
                this.$nextTick(() => {
                    this.$refs["addForm"].clearValidate();
                });
                this.getTargetMainDtlList();
            }
        }
    },
    methods: {
        // 获取指标列表头部
        getTargetMainDtlList() {
            this.loading = true;
            api.getTargetMainDtlList({
                target_main_id: this.target_main_id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.tableColum = res.bus_json;
                    this.getTargetMainDtlDataList();
                }
            });
        },
        // 获取指标列表数据
        getTargetMainDtlDataList() {
            api.getTargetMainDtlDataList({
                target_main_id: this.target_main_id,
                show_day: this.show_day
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.addForm.tableList = this.tableFormat(
                        this.tableColum,
                        res.bus_json
                    );
                    console.log("tableList: ", this.addForm.tableList);
                }
                this.loading = false;
                this.$refs.diaTable.doLayout();
            });
        },
        tableFormat(columnList, tableData) {
            let tableList = [];
            if (tableData.length) {
                tableData.forEach(rowArr => {
                    let row = {};
                    let pointId = rowArr.filter(
                        row => row.target_main_dtl_id == "point_id"
                    )[0].point_id;
                    let groupId =
                        rowArr.filter(
                            row => row.target_main_dtl_id != "point_id"
                        )[0] &&
                        rowArr.filter(
                            row => row.target_main_dtl_id != "point_id"
                        )[0].group_id;
                    columnList.forEach(column => {
                        let colums = rowArr.filter(
                            row =>
                                row.target_main_dtl_id ==
                                column.target_main_dtl_id
                        )[0];
                        if (colums) {
                            row = {
                                ...row,
                                [colums.target_main_dtl_id]:
                                    colums.target_main_dtl_value,
                                real_point_id: pointId,
                                [colums.target_main_dtl_id +
                                    "_" +
                                    colums.target_dtl_data_id]:
                                    colums.target_main_dtl_id +
                                    "_" +
                                    colums.target_dtl_data_id,
                                real_group_id: groupId
                            };
                        }

                        // [colums.target_dtl_data_id]:
                        // colums.target_dtl_data_id,
                    });
                    tableList.push(row);
                });
            }
            return tableList;
        },
        closeDialog() {
            this.dialogVisible = false;
            this.$refs["addForm"].resetFields();
            this.$refs["addForm"].clearValidate();
            this.$emit("update:dialogVisible", this.dialogVisible);
        },
        sumitForm() {
            if (!this.addForm.tableList.length) {
                this.$message.error("请先维护指标管理后，再进行录入保存操作！");
                return;
            }
            this.$refs["addForm"].validate(valid => {
                if (valid) {
                    let arr = [];
                    this.addForm.tableList.forEach(rowItem => {
                        let row = [];
                        for (const column in rowItem) {
                            if (
                                column !== "real_point_id" &&
                                column !== "point_id" &&
                                column !== "data_id" &&
                                column !== "real_group_id"
                            ) {
                                if (column.indexOf("_") < 0) {
                                    let keys = Object.keys(rowItem);
                                    let target_dtl_data_id = "";
                                    keys.forEach(key => {
                                        if (key.indexOf(column + "_") > -1) {
                                            target_dtl_data_id = key.replace(
                                                column + "_",
                                                ""
                                            );
                                        }
                                    });
                                    row.push({
                                        target_main_dtl_id: column,
                                        target_main_dtl_value: rowItem[column],
                                        point_id: rowItem.real_point_id,
                                        target_main_id: this.target_main_id,
                                        target_dtl_data_id: target_dtl_data_id,
                                        group_id: rowItem.real_group_id
                                    });
                                }
                            }
                        }
                        arr.push(row);
                    });
                    if (this.show_day.length) {
                        api.updateTargetDtlData(arr).then(res => {
                            if (res && res.error_code == 0) {
                                this.$message({
                                    message: res.error_msg,
                                    type: "success"
                                });
                                // this.$parent.searchDate = ["", ""];
                                this.$parent.getShowDayList();
                                this.closeDialog();
                            }
                        });
                    } else {
                        api.insertTargetDtlData(arr).then(res => {
                            if (res && res.error_code == 0) {
                                this.$message({
                                    message: res.error_msg,
                                    type: "success"
                                });
                                this.$parent.searchDate = ["", ""];
                                this.$parent.getShowDayList();
                                this.closeDialog();
                            }
                        });
                    }
                } else {
                    this.$message.error("请补全信息");
                }
            });
        },
        changeDate(date) {
            if (this.addForm.tableList.length) {
                let dateKey = this.tableColum.filter(
                    column => column.column_name == "月份"
                )[0].target_main_dtl_id;
                this.addForm.tableList.forEach(row => {
                    row[dateKey] = date;
                });
            }
        }
    }
};
</script>
<style lang="scss">
.target-config-add-container {
    .form-table {
        height: px2Rem(550px);
        .leader-style-table {
            height: 100% !important;
        }
    }
    .el-input__inner {
        // width: 160px;
        // color: #56fcff;
    }
    .el-form-item {
        margin-bottom: 3px !important;
        margin-top: 3px !important;
    }
    .el-form-item__error {
        display: none;
    }
    .el-dialog__body {
        padding: 5px 20px;
    }
}
</style>
